function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { DebounceInput } from 'react-debounce-input';
const noop = () => null;
export const withDebounceInput = function (Input) {
  return ({
    onChange = noop,
    debounceTimeout = 0,
    ...props
  }) =>
  /*#__PURE__*/
  // eslint-disable-next-line no-undef
  React.createElement(DebounceInput, _extends({
    element: Input,
    onChange,
    debounceTimeout
  }, props));
};